import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getPowerBIActionDashboardData = createApi(`PowerBIActionDashboardSlice`,"GET");

const PowerBIActionDashboardSlice = createSlice({
  name: 'PowerBIActionDashboardSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPowerBIActionDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPowerBIActionDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPowerBIActionDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PowerBIActionDashboardSlice.reducer;